import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"

vue.use(vuex);

const pilares = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/pilar`,
    state: {
        pilares: null,
        pillaresallpuntos: null
    }
}).get({
        action: "get_pilarespunto",
        path: function (obj) {
            return `/detalle/${obj.idpunto}/${obj.idperiodo}`;
        },       
        onSuccess: (state, payload ) => {           
            state.pilares = payload.data;        
        },
        onError: (state, error) => {   
            store.dispatch("mensaje/set_error", error);  
            state.pilares = [] ;
        }
    }).get({
        action: "get_pilaresallpunto",
        path: function (obj) {
            return `/detalle/${obj.idpunto}/${obj.idperiodo}`;
        },       
        onSuccess: (state, payload ) => {           
            state.pillaresallpuntos = payload.data;        
        },
        onError: (state, error) => {   
            store.dispatch("mensaje/set_error", error);  
            state.pillaresallpuntos = [] ;
        }
    }).get({
        action: "get_pilaresbycategoria",
        path: function (obj) {
            return `/pilaresfiltrados/${obj.idpunto}/${obj.idclasificacion}/${obj.idperiodo}`;
        },       
        onSuccess: (state, payload ) => {           
            state.pillaresallpuntos = payload.data.filter(p=> p.idpilar != 10);      
        },
        onError: (state, error) => {   
            store.dispatch("mensaje/set_error", error);  
            state.pillaresallpuntos = [] ;
        }
    }).get({
        action: "get_pilares",               
        onSuccess: (state, payload ) => {           
            state.pilares = payload.data;
        },
        onError: (state, error) => {   
            store.dispatch("mensaje/set_error", error);   
        }
    })    
    .getStore();

    pilares.getters = {
    gpilares: state => {
        return state.pilares
    },
    gpilaresall: state => {
        return state.pillaresallpuntos
    },
    gpilarescat: state => {
        return state.pillaresallpuntos;
    },
}

export default pilares;
